import { useRecoilValue } from 'recoil';
import { PUBLIC_LIVE_PAGE } from '../../../constants/app';
import { pageState } from '../../../storage/app';
import ClientCameraProvider from '../../providers/ClientCameraProvider';
import PublicClientProvider from '../../providers/public/PublicClientProvider';
import PublicPusherProvider from '../../providers/public/PublicPusherProvider';
import { SpotsProvider } from '../../providers/SpotsProvider';
import { ZoneFencesProvider } from '../../providers/ZoneFencesProvider';
import PublicDashboardWrapper from '../../shared/public/PublicDashboardWrapper';

export function PublicDashboard() {
  const page = useRecoilValue(pageState);

  return (
    <PublicDashboardWrapper
      providers={
        <>
          {page === PUBLIC_LIVE_PAGE.id && <PublicClientProvider />}
          {page === PUBLIC_LIVE_PAGE.id && <PublicPusherProvider />}
          {page === PUBLIC_LIVE_PAGE.id && <ClientCameraProvider />}
          {page === PUBLIC_LIVE_PAGE.id && <SpotsProvider />}
          {page === PUBLIC_LIVE_PAGE.id && <ZoneFencesProvider />}
        </>
      }
    />
  );
}

export default PublicDashboard;
